module.exports = __webpack_public_path__ + "static/media/move_ITEM_to_DESTINATION.3af1b837.svg";